import React from "react"
import { isEmpty, isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { customNames as customNamesSelector } from "reduxSlices/customNamesSlice"
import CustomNamesListItem from "./CustomNamesListItem"

const CustomNamesList = () => {
  const customNames = useSelector(customNamesSelector, isEqual)

  if (isEmpty(customNames)) {
    return (
      "The organization does not use any custom names."
    )
  }

  return (
    <div>
      {
        customNames.map((customName) => (
          <CustomNamesListItem customName={customName} key={customName.key} />
        ))
      }
    </div>
  )
}

export default CustomNamesList
